import { IntelligentPhotoCaptureArtifactsCategoryNames, IntelligentPhotoCaptureEstimatorCategoryLabelName } from '../enums';
export const IDENTIFY_AS_GROUP_OPTIONS = [
    {
        labelKey: IntelligentPhotoCaptureEstimatorCategoryLabelName.VEHICLE_DAMAGE,
        value: IntelligentPhotoCaptureArtifactsCategoryNames.VEHICLE_DAMAGE
    },
    {
        labelKey: IntelligentPhotoCaptureEstimatorCategoryLabelName.PRIOR_DAMAGE,
        value: IntelligentPhotoCaptureArtifactsCategoryNames.PRIOR_DAMAGE
    },
    {
        labelKey: IntelligentPhotoCaptureEstimatorCategoryLabelName.ADDITIONAL_ARTIFACTS,
        value: IntelligentPhotoCaptureArtifactsCategoryNames.ADDITIONAL_ARTIFACTS
    }
];
//# sourceMappingURL=IntelligentIdentifyAsGroupOptions.js.map